/**
 * Shared eligibility for creating a home plan (or assigning a location plan to a lot)
 * when the plan is multi-unit and the location is not.
 *
 * Callers supply the two booleans (from hydrated client data or server DB lookups).
 */

export type HomePlanCreationBlockReason = "multi_unit_plan_at_single_unit_location";

export type HomePlanCreationEligibility = { ok: true } | { ok: false; reason: HomePlanCreationBlockReason };

export function evaluateHomePlanCreationEligibility({
  atMultiUnitLocation,
  planIsMultiUnit,
}: {
  atMultiUnitLocation: boolean;
  planIsMultiUnit: boolean;
}): HomePlanCreationEligibility {
  if (planIsMultiUnit && !atMultiUnitLocation) {
    return { ok: false, reason: "multi_unit_plan_at_single_unit_location" };
  }
  return { ok: true };
}
